module.exports = __webpack_public_path__ + "img/krathong_1.0a115792.png";